import { PackGroupDTO } from '@/services/api.service';
import { useConfigGroupStore } from '@/stores/configGroup.store';
import styles from './GroupPicker.module.scss';

interface GroupPickerProps {
  groups: PackGroupDTO[];
}

/** Sélecteur multi-groupes en chips inline (Tous / une / plusieurs sections). */
export function GroupPicker({ groups }: GroupPickerProps) {
  const { selectedGroupIds, setSelectedGroupIds } = useConfigGroupStore();

  if (groups.length === 0) {
    return <div className={styles.empty}>Aucun groupe configuré</div>;
  }

  const allIds = groups.map((g) => g.id);
  const allSelected = allIds.every((id) => selectedGroupIds.includes(id));

  const toggle = (id: string) => {
    if (selectedGroupIds.includes(id)) {
      setSelectedGroupIds(selectedGroupIds.filter((x) => x !== id));
    } else {
      setSelectedGroupIds([...selectedGroupIds, id]);
    }
  };

  return (
    <div className={styles.chips}>
      <button
        className={`${styles.chip} ${allSelected ? styles.chipActive : ''}`}
        onClick={() => setSelectedGroupIds(allSelected ? [] : allIds)}
      >
        Tous
      </button>
      {groups.map((g) => {
        const on = selectedGroupIds.includes(g.id);
        const color = g.color || '#8B3FF1';
        return (
          <button
            key={g.id}
            className={`${styles.chip} ${on ? styles.chipActive : ''}`}
            style={on ? { borderColor: color, backgroundColor: `${color}22`, color } : undefined}
            onClick={() => toggle(g.id)}
          >
            <span className={styles.dot} style={{ backgroundColor: color }} />
            {g.name}
          </button>
        );
      })}
    </div>
  );
}
